import { EBankType } from '../../../../../types';
import { IYibaoContactPerson } from '../contact-person/type';

export interface IYibaoOpening extends IYibaoContactPerson {
  id?: number;
  /**
   * 企业信息中的账户类型 (企业端使用，代理商端忽略此字段)
   * @description {@link EBankType}
   */
  bankType?: EBankType;
  /**
   * 银行账户类型
   * @description {@link EBankAccountType}
   */
  bankAccountType?: EBankAccountType;
  /** 开户名称 */
  bankAccountName?: string;
  /** 银行账号（企业基本账号） */
  bankCardNo?: string;
  /** 开户银行code */
  bankCode?: string;
  /** 开户省份code */
  bankProvinceCode?: string;
  /** 开户城市code */
  bankCityCode?: string;
  /** 手动填写的开户支行 - 大额行号 */
  cnapsCode?: string;
  provinceCode?: string;
  cityCode?: string;
  areaCode?: string;
  /** 详细地址 */
  address?: string;
  /** 银行开户许可证 */
  bankOpeningLicense?: string;
  /**
   * 开户支行是否手动填写： YES-是，NO-否
   */
  customStatus?: 'YES' | 'NO';

  /** 开户银行名称 (仅用于前端展示) */
  brabankName?: string;
  /** 手动填写的开户支行name */
  customBankBranchName?: string;
  /** 自动匹配的开户支行name */
  relationBranchBankName?: string;
  /** 自动匹配的开户支行行号(其实就是cnapsCode)  */
  bankBranchNo?: string;
  /** 近三个月发票 */
  transactionReceiptsUrl?: string;
  bankBranch?: string;
  payPassword?: string;
  phoneNo?: string;
  code?: string;
  verifyCode?: string;
}

export enum EBankAccountType {
  /** 单位结算卡 */
  UNIT_SETTLEMENT_CARD = 'UNIT_SETTLEMENT_CARD',
  /** 对公账户 */
  ENTERPRISE_ACCOUNT = 'ENTERPRISE_ACCOUNT',
  /** 借记卡 */
  DEBIT_CARD = 'DEBIT_CARD',
  /** 存折 */
  PASSBOOK = 'PASSBOOK',
}

export const enterpriseBankAccTypes = [
  {
    value: EBankAccountType.ENTERPRISE_ACCOUNT,
    label: '对公账户',
  },
  {
    value: EBankAccountType.UNIT_SETTLEMENT_CARD,
    label: '单位结算卡',
  },
];

export const personalBankAccTypes = [
  ...enterpriseBankAccTypes,
  {
    value: EBankAccountType.DEBIT_CARD,
    label: '借记卡',
  },
  {
    value: EBankAccountType.PASSBOOK,
    label: '存折',
  },
];
